// @flow
import { spawn } from "redux-saga/effects";
import myAbsenceStageSaga from "./my-absence-stage";
import myAbsencesSaga from "./my-absences";
import myDetailsSaga from "./my-details";
import myEmployeesSaga from "./my-employees";

export default function* profileSaga(): Generator<*, void, void> {
  yield spawn(myAbsenceStageSaga);
  yield spawn(myAbsencesSaga);
  yield spawn(myDetailsSaga);
  yield spawn(myEmployeesSaga);
}
